module.exports = __webpack_public_path__ + "img/gill2.5c105d57.svg";